import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './i18n';
import App from './App';
import { initSentry } from './utils/sentry';

// 初始化 Sentry 错误监控
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA
// 预发阶段：不在每次加载时 skipWaiting，避免部署后标签页反复被接管刷新的体感
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// iOS 灵动岛 / Dynamic Island 基础支持
if (typeof window !== 'undefined' && 'mediaSession' in navigator) {
  // 为未来的灵动岛通话状态做准备
  navigator.mediaSession.setActionHandler('previoustrack', null);
  navigator.mediaSession.setActionHandler('nexttrack', null);
}
